export default (string, currency = false) => {
  if (!string) {
    return "";
  }
  if (!isNaN(string)) {
    if (!currency) {
      return string;
    }
  }
  if (string.length <= 0) {
    return "";
  }
  let stringArray = persianNumberToEnglish(string);
  stringArray = stringArray.replace(/\D/g, "");
  if (currency) {
    let num = stringArray.split(",").join("");
    let result = "";
    let j = 0;
    for (let i = num.length - 1; i >= 0; i--) {
      result += num[j];
      if (i % 3 === 0) {
        result += ",";
      }
      j++;
    }
    if (result.substr(-1) === ",") {
      result = result.substr(0, result.length - 1);
    }
    if (result.substr(0, 1) === "-") {
      result = result.substr(1, result.length);
      if (result.substr(0, 1) === ",") {
        result = result.substr(1, result.length);
      }
      result = "(" + result + ")";
    }
    return result;
  } else {
    return stringArray;
  }
};

const persianNumberToEnglish = num => {
  if (num === null) {
    return num;
  }
  num = num.toString();
  for (let i = 0; i < num.length; i++) {
    const startPoint = num.indexOf(num[i]);
    const endPoint = num[i].length + startPoint;
    let theFirst = num.substring(0, startPoint);
    let theWord = num.substring(startPoint, endPoint);
    const theRest = num.substring(endPoint, num.length + endPoint);
    for (let j = 0; j < persianNumbers.length; j++) {
      if (num[i].toString() === persianNumbers[j].toString()) {
        if (startPoint !== -1) {
          theWord = englishNumbers[j];
          num = theFirst.toString() + theWord.toString() + theRest.toString();
        }
      }
    }
  }
  return num;
};

const persianNumbers = [
  "۰",
  "۱",
  "۲",
  "۳",
  "۴",
  "۵",
  "۶",
  "۷",
  "۸",
  "۹",
  "۰",
  "١",
  "٢",
  "٣",
  "٤",
  "٥",
  "٦",
  "٧",
  "٨",
  "٩"
];
const englishNumbers = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9"
];
